import { SET_INFO_PAGE, CALL_ME_ERROR, CALL_ME_SUCCESS } from "../actions/infoHelp";

const INITIAL_STATE = {
  statusMessage: "",
  helpText: "",
  callMe: false
};

export const infoHelpReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_INFO_PAGE:
      return action.payload ;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/infoHelp.js